__turbopack_context__.v({
  "column": "Column-module__UuNlaa__column",
  "width-1_2": "Column-module__UuNlaa__width-1_2",
  "width-1_3": "Column-module__UuNlaa__width-1_3",
  "width-1_4": "Column-module__UuNlaa__width-1_4",
  "width-1_5": "Column-module__UuNlaa__width-1_5",
  "width-2_3": "Column-module__UuNlaa__width-2_3",
  "width-2_5": "Column-module__UuNlaa__width-2_5",
  "width-3_4": "Column-module__UuNlaa__width-3_4",
  "width-3_5": "Column-module__UuNlaa__width-3_5",
  "width-4_5": "Column-module__UuNlaa__width-4_5",
});
